<section class="detail-card">
  <h4>Identity</h4>
  <div class="detail-field">
    <label>Name</label>
    <span>{{ collector.name }}</span>
  </div>
  <div class="detail-field">
    <label>Email</label>
    <span>{{ collector.email || '—' }}</span>
  </div>
  <div class="detail-field">
    <label>Created At</label>
    <span>{{ collector.created_at || '—' }}</span>
  </div>
  <ng-container *ngIf="showProfileFields">
    <div class="detail-field">
      <label>Team</label>
      <span>{{ collector.team || '—' }}</span>
    </div>
    <div class="detail-field">
      <label>Role</label>
      <span>{{ collector.role || '—' }}</span>
    </div>
    <div class="detail-field">
      <label>Discord Alias</label>
      <span>{{ collector.discordAlias || '—' }}</span>
    </div>
  </ng-container>
</section>
